<template>
  <div class="addCar">
    <van-popup
      v-model="show"
      position="bottom"
      :close-on-click-overlay="false"
    >
      <div class="header">
        <div class="title">请填写驾驶证信息处理扣分</div>
        <van-icon name="cross" color="#383838" @click="close" size="0.3rem" />
      </div>
      <div class="content">
        <van-form>
          <van-field v-model="formData.drivingLicense"  :rules="rules.drivingLicense" label="驾驶证号" placeholder="请输入" label-class="fieldLabel" class="input" />
          <van-field v-model="formData.drivingLicenseFile" :rules="rules.drivingLicenseFile" label="驾驶证档案编号" placeholder="请输入" label-class="fieldLabel" label-width="2.5rem" class="input" />
          <van-field v-model="formData.drivingLicenseCore" :rules="rules.drivingLicenseCore" label="证芯编号" placeholder="请输入" type="number" maxlength="13" label-class="fieldLabel" class="input" />
        </van-form>
      </div>
      <div class="btn">
        <van-button type="info" @click="submit" size="large">继续处理</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
import schema from 'async-validator'
export default {
  name: "",
  components: {
  },
  props: {
    isPointDeal: {
      type: Boolean
    }
  },
  data() {
    return {
      show: false,
      formData: {},
      rules: {
        drivingLicense: [
          { required: true, message: '驾驶证号不能为空' },
          { pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '请输入正确的驾驶证号' }
        ],
        drivingLicenseFile: [
          { required: true, message: '驾驶证档案编号不能为空' },
          { pattern: /^[1-8]\d{11}$/, message: '请输入正确的驾驶证档案编号' }
        ],
        drivingLicenseCore: [
          { required: true, message: '证芯编号不能为空' },
          { pattern: /^\d{13}$/, message: '请输入正确的证芯编号' }
        ]
      }
    }
  },
  watch: {
    isPointDeal(val) {
      this.show = val
    },
  },
  methods: {
    async submit() {
      const validator = new schema(this.rules)
      try {
				await validator.validate(this.formData)
			} catch ({ errors }) {
				this.$toast(errors[0].message)
				return
			}
      this.show = false
      this.$emit('submit', this.formData)
    },
    close() {
      this.show = false
      this.$emit('close')
    }
  }
}
</script>
<style scoped lang="scss">
.addCar{
  .header{
    height: 1rem;
    line-height: 1rem;
    border-bottom: 1px solid #F4F6F7;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.3rem;
    box-sizing: border-box;
    .title{
      color: #383838;
      font-size: 0.32rem;
    }
  }
  .content{
    padding: 0 0.3rem;
    box-sizing: border-box;
    .input{
      border: 1px solid #ccc;
      border-radius: 0.2rem;
      margin-top: 0.3rem;
      /deep/ .fieldLabel{
        font-size: 0.3rem;
        color: #787878;
        ::after{
          content: '*';
          color: #EA3F26;
        }
      }
    }
  }
  .btn{
    // position: fixed;
    // bottom: 0.3rem;
    width: 100vw;
    height: 2rem;
    padding: 0 0.3rem;
    line-height: 1.8rem;
    box-sizing: border-box;
    /deep/ .van-button{
      border-radius: 0.16rem;
    }
  }
}
</style>